module.exports = __webpack_public_path__ + "img/26_114.5993bc7e.png";